import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372ccf82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "register-form__title" }, "Cadastre-se", -1))
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = { class: "foreigner" }
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "foreigner" }, "Sou estrangeiro", -1))
const _hoisted_7 = { class: "pair" }
const _hoisted_8 = { class: "date-input-container" }
const _hoisted_9 = { class: "pair" }
const _hoisted_10 = { class: "pair" }
const _hoisted_11 = { class: "pair" }
const _hoisted_12 = { class: "pair" }
const _hoisted_13 = { class: "pair" }
const _hoisted_14 = { class: "container-password" }
const _hoisted_15 = { class: "pair pair--terms" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  required: "",
  id: "terms",
  type: "checkbox",
  class: "input__terms"
}, null, -1))
const _hoisted_17 = {
  class: "label__terms",
  for: "terms"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Aceito os ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("termos de uso")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "register-form__button",
  type: "submit"
}, "Cadastrar", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModernInput = _resolveComponent("ModernInput")!
  const _component_input_password = _resolveComponent("input-password")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "register-modal",
    onClick: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "button--exit",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleRegisterModal')))
      }, " X "),
      _createElementVNode("form", {
        onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"])),
        id: "register-form",
        class: "register-form"
      }, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              type: "checkbox",
              id: "foreigner",
              value: _ctx.user.isForeigner,
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setForeigner($event.target)))
            }, null, 40, _hoisted_5),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ModernInput, {
              form: "register-form",
              required: "",
              class: "modern-input",
              id: "register-name",
              label: "Nome",
              type: "text",
              userData: _ctx.user.name,
              "onUpdate:userData": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.name) = $event)),
              color: "var(--color-black-dark)"
            }, null, 8, ["userData"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", {
                for: "input-date",
                class: _normalizeClass(['label-date', 'required', { focus: _ctx.isInputFocused }])
              }, " Data de nascimento", 2),
              _createElementVNode("input", {
                class: "input-date",
                id: "input-date",
                type: "text",
                maxlength: "10",
                placeholder: "dd/mm/yyyy",
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.user.birthDate && _ctx.user.birthDate(...args))),
                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
                onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleLabelClass($event.target.value, true))),
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleLabelClass($event.target.value, false)))
              }, null, 32)
            ])
          ]),
          _createVNode(_component_ModernInput, {
            form: "register-form",
            class: "modern-input",
            id: "register-document",
            label: "CPF",
            type: "text",
            userData: _ctx.user.document,
            "onUpdate:userData": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.document) = $event)),
            "has-mask": "",
            "input-mask": "###.###.###-##",
            color: "var(--color-black-dark)",
            required: "",
            disabled: _ctx.user.isForeigner
          }, null, 8, ["userData", "disabled"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_ModernInput, {
              form: "register-form",
              required: "",
              class: "modern-input",
              id: "register-email",
              label: "E-mail",
              type: "email",
              userData: _ctx.user.email,
              "onUpdate:userData": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.email) = $event)),
              color: "var(--color-black-dark)"
            }, null, 8, ["userData"]),
            _createVNode(_component_ModernInput, {
              "max-length": "14",
              form: "register-form",
              class: "modern-input",
              id: "register-CEP",
              label: "CEP",
              type: "text",
              userData: _ctx.user.address.zipCode,
              "onUpdate:userData": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.user.address.zipCode) = $event)),
              "has-mask": "",
              "input-mask": "#####-###",
              color: "var(--color-black-dark)"
            }, null, 8, ["userData"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_ModernInput, {
              form: "register-form",
              userData: _ctx.user.address.stateID,
              "onUpdate:userData": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.user.address.stateID) = $event)),
              class: "modern-input",
              id: "register-uf",
              label: "UF (Estado)",
              type: "select",
              options: _ctx.states,
              color: "var(--color-black-dark)"
            }, null, 8, ["userData", "options"]),
            _createVNode(_component_ModernInput, {
              form: "register-form",
              userData: _ctx.user.address.city,
              "onUpdate:userData": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.address.city) = $event)),
              class: "modern-input",
              id: "register-city",
              label: "Cidade",
              type: "text",
              color: "var(--color-black-dark)"
            }, null, 8, ["userData"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_ModernInput, {
              form: "register-form",
              "user-data": _ctx.user.address.street,
              "onUpdate:user-data": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.user.address.street) = $event)),
              class: "modern-input",
              id: "register-street",
              label: "Rua",
              type: "text",
              color: "var(--color-black-dark)"
            }, null, 8, ["user-data"]),
            _createVNode(_component_ModernInput, {
              form: "register-form",
              "user-data": _ctx.user.address.district,
              "onUpdate:user-data": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.user.address.district) = $event)),
              class: "modern-input",
              id: "register-neighborhood",
              label: "Bairro",
              type: "text",
              color: "var(--color-black-dark)"
            }, null, 8, ["user-data"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ModernInput, {
              form: "register-form",
              "user-data": _ctx.user.address.addressNumber,
              "onUpdate:user-data": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.user.address.addressNumber) = $event)),
              min: "0",
              class: "modern-input",
              id: "register-number",
              label: "Número",
              type: "number",
              color: "var(--color-black-dark)"
            }, null, 8, ["user-data"]),
            _createVNode(_component_ModernInput, {
              form: "register-form",
              "user-data": _ctx.user.address.complement,
              "onUpdate:user-data": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.user.address.complement) = $event)),
              class: "modern-input",
              id: "register-complement",
              label: "Complemento",
              type: "text",
              color: "var(--color-black-dark)"
            }, null, 8, ["user-data"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_input_password, {
              form: "register-form",
              required: "",
              "model-value": _ctx.user.password,
              "onUpdate:model-value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.user.password) = $event)),
              id: "register-password",
              label: "Senha",
              passwordVisibility: true,
              "input-color": "var(--color-black-dark)"
            }, null, 8, ["model-value"]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_ModernInput, {
                form: "register-form",
                required: "",
                "user-data": _ctx.user.passwordConfirmation,
                "onUpdate:user-data": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.user.passwordConfirmation) = $event)),
                id: "register-passwordConfirmation",
                label: "Confirme sua senha",
                type: _ctx.isPasswordVisible ? 'text' : 'password',
                color: "var(--color-black-dark)"
              }, null, 8, ["user-data", "type"]),
              _createElementVNode("span", {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.togglePassword())),
                class: _normalizeClass(["input__visibility", _ctx.isPasswordVisible ? '' : 'notVisible'])
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("label", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_router_link, {
                to: { name: 'terms' },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_20
      ], 32)
    ])
  ]))
}